import { IMetaPaginationData, MetaPaginationRecord, metaPaginationFromJSON } from "common/records/MetaPagination";
import { IQueryParamsData, QueryParamsRecord, queryParamsFromJSON } from "common/records/QueryParams";
import { List, Record } from "immutable";
import { IdType, Nullable } from "common/types";

export const idsManagementFromJSON = (json: Partial<IIdsManagementData>): IIdsManagementRecord => {
  const recordData: IIdsManagementRecord = { ...(json as any) };

  if (recordData.ids) {
    recordData.ids = List(recordData.ids);
  }
  if (json.metaPagination) {
    recordData.metaPagination = metaPaginationFromJSON(json.metaPagination);
  }
  if (json.queryParams) {
    recordData.queryParams = queryParamsFromJSON(json.queryParams);
  }

  return new IdsManagementRecord(recordData);
};

export interface IIdsManagementData {
  ids: IdType[];
  loading: boolean;
  metaPagination?: Partial<IMetaPaginationData>;
  queryParams?: Partial<IQueryParamsData>;
}

export interface IIdsManagementRecord {
  ids: List<IdType>;
  loading: boolean;
  metaPagination: Nullable<MetaPaginationRecord>;
  queryParams: Nullable<QueryParamsRecord>;
}

const defaultProps: IIdsManagementRecord = {
  ids: List(),
  loading: false,
  metaPagination: null,
  queryParams: null,
};

export class IdsManagementRecord extends Record(defaultProps) implements IIdsManagementRecord {}
